/*请求 基本信息配置*/
import Qs from 'qs'
// const baseURL = 'https://csydyc1.zwjk.com';
// const baseURL = 'http://csydyc.zwjk.com';
// const baseURL = 'http://csysfw.zwjk.com';
// const baseURL = 'http://localhost:9999';

// const ysURL = 'https://ysgldev.zwjk.com/cph/'; //药事测试
// const longPollingUrl = "http://diagnose.zwjk.com"; //cos图片上传地址


/**
 * 演示
 * @type {string}
 */
// const baseURL = 'http://ysydycht.zwjk.com';
// const ysURL = 'https://ysgltest.zwjk.com/cph/'; //药事测试
// const longPollingUrl = "http://diagnose.zwjk.com"; //cos图片上传地址


/**
 * 河南生产
 * @type {string}
 */
// const baseURL = 'http://ymz.ylxz.o2omed.com.cn/'; //河南生产
// const longPollingUrl = "http://diagnose.zwjk.com"; //cos图片上传地址
// const ysURL = 'https://yscph.zwjk.com/yscph_new/'; //药事生产

/**
 * 云生产
 * @type {string}
 */
// const baseURL = 'http://ymzydyc.zwjk.com/'; //云生产
const baseURL = 'http://premydyc.zwjk.com/'; //云生产
const longPollingUrl = "http://diagnose.zwjk.com"; //cos图片上传地址
const ysURL = 'https://yscph.zwjk.com/yscph_new/'; //药事生产



/**
 * 九和生产
 * @type {string}
 */

// const baseURL = 'https://ydyc.xinyilu.com/'; //九和生产
// const longPollingUrl = "https://diagnose.zwjk.com"; //cos图片上传地址
// const ysURL = 'https://ysfw.xinyilu.com/yscph_new/'; //药事生产
// // const ysURL = 'https://yscph.zwjk.com/yscph_new/'; //药事生产

/**
 * rubikS
 * @type {string}
 */

// const baseURL = 'https://superymz.zwjk.com/'; //rubikS生产
// const longPollingUrl = "https://diagnose.zwjk.com"; //cos图片上传地址
// const ysURL = 'https://superysfwpt.zwjk.com/'; //药事生产
// const ysURL = 'https://yscph.zwjk.com/yscph_new/'; //药事生产

/**
 * 上海思睿明生产
 */
// const baseURL = 'https://ymzshsrm.zwjk.com/'; //上海思睿明
// const longPollingUrl = "https://diagnose.zwjk.com"; //cos图片上传地址
// const ysURL = 'https://yscph.zwjk.com/yscph_new/'; //药事生产


/**
 * 东营市互联网医院
 * @type {string}
 */
// const baseURL = 'https://ymz.dyjk.gov.cn/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://ysfw.dyjk.gov.cn/yscph_new/';

/**
 * 深圳眼科
 * @type {string}
 */
// const baseURL = 'https://ymz.sz-eyes.com/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://ysfw.sz-eyes.com/yscph_new/';

/**
 * 淳安
 * @type {string}
 */
// const baseURL = 'http://tm.qdhws.gov.cn:18989/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://yscph.zwjk.com/yscph_new/';


/**
 *兴齐互联网医院
 * @type {string}
 */
// const baseURL = 'https://hwyydyc.zwjk.com/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://hwyysptweb.zwjk.com/yscph_new/';

/**
 *滨医烟台附院
 * @type {string}
 */
// const baseURL = 'https://byymz.zwjk.com/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://byysfw.zwjk.com/yscph_new/';

/**
 * 山东中医药大学附属医院
 * @type {string}
 */
// const baseURL = 'https://ymz.sdzydfy.com:4430/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://ysfw.sdzydfy.com:4430/yscph_new/';


/**
 * 烟台业达
 * @type {string}
 */
// const baseURL = 'https://ydycydyy.zwjk.com:9997/';
// const longPollingUrl = "https://diagnose.zwjk.com";
// const ysURL = 'https://ysxfydyy.zwjk.com:9997/yscph_new/';


const basePayURL = '/mzgr.html#/'; //支付


const objBase = {
    //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: '/get',

    // 请求方法同上
    method: 'get', // default
    // 基础url前缀
    baseURL: baseURL,
    // 请求头信息
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    transformRequest: [
        function(data) {
            // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
            data = Qs.stringify(data);
            return data;
        }
    ],
    // `paramsSerializer` 是一个负责 `params` 序列化的函数
    paramsSerializer: function(params) {
        return Qs.stringify(params)
    },
    //设置超时时间
    // timeout: 5000,

    // `withCredentials` 表示跨域请求时是否需要使用凭证
    withCredentials: true, // default

    //返回数据类型
    responseType: 'json' // default
}
const modelBase = {
    //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: '/get',

    // 请求方法同上
    method: 'get', // default
    // 基础url前缀
    baseURL: baseURL,
    // 请求头信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    //设置超时时间it
    // timeout: 5000,

    // `withCredentials` 表示跨域请求时是否需要使用凭证
    withCredentials: true, // default

    //返回数据类型
    responseType: 'json' // default
}

export const CookieDomain = (process.env.NODE_ENV === 'production') ?
    '.jackhu.top' :
    ''

export {
    longPollingUrl,
    ysURL,
    baseURL,
    objBase,
    modelBase,
    basePayURL,
}



// WEBPACK FOOTER //
// ./src/util/config.js